package org.example.zone360.pages.widgets.competitiveWidget

import org.example.zone360.components.debugPrintln

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderBottom
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.whiteSpace
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.icons.fa.FaArrowDown
import com.varabyte.kobweb.silk.components.icons.fa.FaArrowUp
import com.varabyte.kobweb.silk.components.icons.fa.FaBullseye
import com.varabyte.kobweb.silk.components.icons.fa.FaClock
import com.varabyte.kobweb.silk.components.icons.fa.FaFlag
import com.varabyte.kobweb.silk.components.icons.fa.FaTrophy
import com.varabyte.kobweb.silk.components.icons.fa.FaUser
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.example.zone360.utils.getWidgetDetail
import kotlinx.browser.window
import org.example.zone360.components.ProgressIndicator
import org.example.zone360.components.getAvatarColor
import org.example.zone360.componentss.FieldTitleTextNormalSimple
import org.example.zone360.models.WidgetDetailPayload
import org.example.zone360.models.WidgetDetailResponse
import org.example.zone360.theme.Palette
import org.example.zone360.theme.toSitePalette
import org.example.zone360.utils.AppGlobal
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

@Composable
fun CompetitiveModal(
    widgetNo: Int,
    widgetName: String,
    widgetColor: Color,
    response: WidgetDetailResponse?,
    widgetKey: String,
    clubAverage: Int,
    onClose: () -> Unit,
) {
    val sitePalette = ColorMode.current.toSitePalette()
    val breakpoint = rememberBreakpoint()

    var localData by remember { mutableStateOf<WidgetDetailResponse?>(null) }
    var isLoading by remember { mutableStateOf(true) }
    var selectedSortColumn by remember { mutableStateOf<String?>(null) }
    var isAscending by remember { mutableStateOf(true) }

    LaunchedEffect(Unit) {
        isLoading = true
        try {
            localData = getWidgetDetail(
                WidgetDetailPayload(
                    organization = AppGlobal.userData.organization,
                    seasonID = AppGlobal.selectedSeasonId,
                    widgetKey = widgetKey
                )
            )
        } catch (e: Exception) {
            debugPrintln("Failed to fetch widget detail: ${e.message}")
        } finally {
            isLoading = false
        }
    }

    val effectiveData = response ?: localData
    val coachList = effectiveData?.coaches ?: emptyList()
    val clubAvg = effectiveData?.clubAverage?.toInt() ?: clubAverage
    val coach = coachList.firstOrNull()

    val sortedCoaches = when (selectedSortColumn) {
        "COACH" -> if (isAscending) coachList.sortedBy { it.coachName.lowercase() }
        else coachList.sortedByDescending { it.coachName.lowercase() }
        "SCORE" -> if (isAscending) coachList.sortedBy { it.score }
        else coachList.sortedByDescending { it.score }
        else -> coachList
    }

    Box(
        modifier = Modifier
            .styleModifier {
                property("position", "fixed")
                property("top", "0")
                property("left", "0")
                property("right", "0")
                property("bottom", "0")
                property("z-index", "99999")
                property("background-color", "rgba(0,0,0,0.7)")
                property("display", "flex")
                property("align-items", "center")
                property("justify-content", "center")
            }
            .onClick { onClose() }
    ) {
        Box(
            modifier = Modifier
                .backgroundColor(sitePalette.modalBackgroundColor.rgb)
                .borderRadius(16.px)
                .padding(24.px, if (breakpoint < Breakpoint.MD) 15.px else 25.px)
                .styleModifier {
                    property("width", "90%")
                    property("max-width", "450px")
                    property("max-height", "85vh")
                    property("overflow-y", "auto")
                    property("box-shadow", "0 20px 50px rgba(0,0,0,0.25)")
                }
                .onClick { it.stopPropagation() }
        ) {
            Column(modifier = Modifier.fillMaxWidth()) {

                // ── Header ────────────────────────────────────────
                Row(
                    modifier = Modifier.fillMaxWidth().margin(bottom = 18.px),
                    verticalAlignment = Alignment.CenterVertically,
                ) {
                    Box(
                        modifier = Modifier
                            .width(28.px)
                            .height(28.px)
                            .backgroundColor(widgetColor)
                            .borderRadius(6.px)
                            .margin(right = 10.px),
                        contentAlignment = Alignment.Center
                    ) {
                        FieldTitleTextNormalSimple(
                            text = widgetNo.toString(),
                            fontSize = 14.px,
                            fontWeight = 700,
                            color = sitePalette.bodyBackground.rgb
                        )
                    }
                    FieldTitleTextNormalSimple(
                        text = widgetName,
                        fontSize = 16.px,
                        fontWeight = 700
                    )
                    Spacer()
                    Box(
                        modifier = Modifier
                            .cursor(Cursor.Pointer)
                            .onClick { onClose() }
                    ) {
                        SpanText(
                            text = "✕",
                            modifier = Modifier.fontSize(18.px).fontWeight(700)
                        )
                    }
                }

                    // ── Sub-score rows ────────────────────────────
                if (isLoading) {
                    Box(
                        modifier = Modifier.fillMaxWidth().height(180.px),
                        contentAlignment = Alignment.Center
                    ) {
                        ProgressIndicator(size = 30.px)
                    }
                } else {
                    Column(
                        modifier = Modifier.fillMaxWidth().margin(bottom = 16.px)
                    ) {
                        CompetitiveMetricRow(
                            label = "Competition",
                            value = coach?.subScores?.competition?.toInt() ?: 0,
                            icon = { FaTrophy(size = IconSize.SM, modifier = Modifier.color(Color.rgb(59, 109, 17))) },
                            iconBg = Color.rgb(234, 243, 222),
                            barColor = Color.rgb(99, 153, 34)
                        )
                        CompetitiveMetricRow(
                            label = "Accountability",
                            value = coach?.subScores?.accountability?.toInt() ?: 0,
                            icon = { FaUser(size = IconSize.SM, modifier = Modifier.color(Color.rgb(133, 79, 11))) },
                            iconBg = Color.rgb(250, 238, 218),
                            barColor = Color.rgb(239, 159, 39)
                        )
                        CompetitiveMetricRow(
                            label = "Scoring systems",
                            value = coach?.subScores?.scoringSystems?.toInt() ?: 0,
                            icon = { FaBullseye(size = IconSize.SM, modifier = Modifier.color(Color.rgb(59, 109, 17))) },
                            iconBg = Color.rgb(234, 243, 222),
                            barColor = Color.rgb(99, 153, 34)
                        )
                        CompetitiveMetricRow(
                            label = "Time pressure",
                            value = coach?.subScores?.timePressure?.toInt() ?: 0,
                            icon = { FaClock(size = IconSize.SM, modifier = Modifier.color(Color.rgb(59, 109, 17))) },
                            iconBg = Color.rgb(234, 243, 222),
                            barColor = Color.rgb(99, 153, 34)
                        )
                        CompetitiveMetricRow(
                            label = "Win criteria",
                            value = coach?.subScores?.winningConditions?.toInt() ?: 0,
                            icon = { FaFlag(size = IconSize.SM, modifier = Modifier.color(Color.rgb(133, 79, 11))) },
                            iconBg = Color.rgb(250, 238, 218),
                            barColor = Color.rgb(239, 159, 39)
                        )
                    }
                    }

//                if (isLoading) {
//                    Box(
//                        modifier = Modifier.fillMaxWidth().height(300.px),
//                        contentAlignment = Alignment.Center
//                    ) {
//                        ProgressIndicator(size = 30.px)
//                    }
//                } else {

                    // ── Score + Club avg pill ─────────────────────
                    Row(
                        verticalAlignment = Alignment.CenterVertically,
                        modifier = Modifier.fillMaxWidth().margin(bottom = 16.px)
                    ) {
                        Row(
                            verticalAlignment = Alignment.Bottom,
                            modifier = Modifier.weight(1)
                        ) {
                            FieldTitleTextNormalSimple(
                                text = "${coach?.score ?: 0}",
                                fontSize = 32.px,
                                fontWeight = 500
                            )
                            FieldTitleTextNormalSimple(
                                text = "/100",
                                fontSize = 13.px,
                                fontWeight = 400,
                                color = Palette.CoachTalkTableHeaderText.rgbLight,
                                marginLeft = 2.px
                            )
                        }
                        Box(
                            modifier = Modifier
                                .backgroundColor(Color.rgb(234, 243, 222))
                                .borderRadius(99.px)
                                .padding(leftRight = 10.px, topBottom = 4.px),
                            contentAlignment = Alignment.Center
                        ) {
                            FieldTitleTextNormalSimple(
                                text = "Club avg $clubAvg",
                                fontSize = 11.px,
                                fontWeight = 500,
                                color = Color.rgb(59, 109, 17)
                            )
                        }
                    }

                    // ── Coach table ───────────────────────────────
                    Column(
                        modifier = Modifier
                            .fillMaxWidth()
                            .overflow(Overflow.Auto)
                            .borderRadius(12.px)
                            .styleModifier {
                                property("border", "1px solid #E5EAF3")
                            }
                    ) {
                        // Table header
                        Row(
                            modifier = Modifier
                                .fillMaxWidth()
                                .gap(10.px)
                                .backgroundColor(Color.rgb(248, 250, 252))
                                .padding(leftRight = 20.px, topBottom = 10.px)
                                .borderBottom(1.px, LineStyle.Solid, Color.rgb(229, 234, 243)),
                            horizontalArrangement = Arrangement.SpaceBetween,
                            verticalAlignment = Alignment.CenterVertically
                        ) {
                            listOf("COACH", "SCORE").forEachIndexed { index, label ->
                                Row(
                                    modifier = Modifier
                                        .width(
                                            when {
                                                index == 0 && window.screen.width < 768 -> 115.px
                                                index == 0 -> 170.px
                                                else -> 80.px
                                            }
                                        )
                                        .cursor(Cursor.Pointer)
                                        .onClick {
                                            if (selectedSortColumn == label) isAscending = !isAscending
                                            else { selectedSortColumn = label; isAscending = true }
                                        },
                                    verticalAlignment = Alignment.CenterVertically
                                ) {
                                    FieldTitleTextNormalSimple(
                                        text = label,
                                        fontSize = 11.px,
                                        fontWeight = 500,
                                        color = Palette.CoachTalkTableHeaderText.rgbLight
                                    )
                                    if (selectedSortColumn == label) {
                                        Box(modifier = Modifier.margin(left = 5.px)) {
                                            if (isAscending) FaArrowUp(
                                                modifier = Modifier.fontSize(10.px)
                                                    .color(Palette.CoachHeaderGradientOne.rgbLight)
                                            ) else FaArrowDown(
                                                modifier = Modifier.fontSize(9.px)
                                                    .color(Palette.CoachHeaderGradientOne.rgbLight)
                                            )
                                        }
                                    }
                                }
                            }
                        }

                        // Table body
                        Column(
                            modifier = Modifier
                                .fillMaxWidth()
                                .height(260.px)
                                .overflow(Overflow.Auto)
                        ) {
                            sortedCoaches.forEachIndexed { rowIndex, coach ->
                                val avatarColor = getAvatarColor(coach.coachName)
                                val initials = coach.coachName
                                    .split(" ")
                                    .take(1)
                                    .joinToString("") { it.firstOrNull()?.toString() ?: "" }
                                    .uppercase()

                                Row(
                                    modifier = Modifier
                                        .fillMaxWidth()
                                        .gap(10.px)
                                        .backgroundColor(
                                            if (rowIndex % 2 == 0) sitePalette.modalBackgroundColor.rgb
                                            else Color.rgb(250, 251, 252)
                                        )
                                        .padding(
                                            leftRight = if (breakpoint < Breakpoint.MD) 10.px else 20.px,
                                            topBottom = 10.px
                                        )
                                        .borderBottom(1.px, LineStyle.Solid, Color.rgb(241, 245, 249)),
                                    horizontalArrangement = Arrangement.SpaceBetween,
                                    verticalAlignment = Alignment.CenterVertically
                                ) {
                                    // Coach column
                                    Row(
                                        modifier = Modifier.width(
                                            if (window.screen.width < 768) 150.px else 190.px
                                        ),
                                        verticalAlignment = Alignment.CenterVertically
                                    ) {
                                        Box(
                                            modifier = Modifier
                                                .width(if (breakpoint < Breakpoint.MD) 25.px else 30.px)
                                                .height(if (breakpoint < Breakpoint.MD) 25.px else 30.px)
                                                .backgroundColor(avatarColor.bg)
                                                .borderRadius(50.percent)
                                                .margin(right = 10.px),
                                            contentAlignment = Alignment.Center
                                        ) {
                                            SpanText(
                                                text = initials,
                                                modifier = Modifier
                                                    .fontSize(11.px)
                                                    .fontWeight(500)
                                                    .color(avatarColor.text)
                                            )
                                        }
                                        SpanText(
                                            text = coach.coachName,
                                            modifier = Modifier
                                                .fontSize(13.px)
                                                .fontWeight(400)
                                                .overflow(Overflow.Hidden)
                                                .whiteSpace(WhiteSpace.NoWrap)
                                                .styleModifier {
                                                    property("text-overflow", "ellipsis")
                                                }
                                        )
                                    }

                                    // Score column
                                    FieldTitleTextNormalSimple(
                                        text = "${coach.score}",
                                        width = 80.px,
                                        fontSize = 11.px,
                                        fontWeight = 500
                                    )
                                }
                            }
                        }
                    }
//                }
            }
        }
    }
}